import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core'
import {TerminalEvent} from '../../interfaces/terminal-event'
import {first, map, Observable, shareReplay} from 'rxjs'

export interface detailViewSegment {
  title: string
  data: detailViewRow[]
}
export interface detailViewRow {
  label?: string
  key?: string
  value?: string | number | null
  selected: boolean
  ingestSequence: number
}

@Component({
  selector: 'app-terminal-events-detail',
  templateUrl: './terminal-events-detail.component.html',
  styleUrls: ['./terminal-events-detail.component.scss'],
  standalone: false,
})
export class TerminalEventsDetailComponent implements OnInit {
  @Input() data$: Observable<TerminalEvent>
  mappedData$!: Observable<TerminalEvent>
  @Input() selectedFilters$: Observable<TerminalEvent>
  @Input() isBig: boolean
  @Input() configurationFileName: string =
    'TerminalEventsFieldDefinitionsByType_detail.json'
  @Input() eventName: string = 'sourceName'

  @Output() detailAttributeChanged = new EventEmitter<{
    filter: {key: string; value: string | number | boolean}
    ingestSequence: number
    setSelected: boolean
  }>()
  @Output() detailSizeChanged = new EventEmitter<{detailBig: boolean}>()
  @Output() jump = new EventEmitter<{type: string; direction: string}>()
  @Output() reset = new EventEmitter<boolean>()

  detailBig = true

  constructor() {}

  ngOnInit() {
    this.detailBig = this.isBig
    this.mappedData$ = this.data$.pipe(
      first(),
      map((e) => {
        const appDD = e['APP-DD']
        if (appDD) {
          e['APP-DD'] = this.hexToAscii(appDD) + ' (' + appDD + ')'
        }
        return e
      }),
      shareReplay(1),
    )
  }

  selectFilter(value) {
    this.detailAttributeChanged.emit(value)
  }

  toggleSize() {
    this.detailBig = !this.detailBig
    this.detailSizeChanged.emit({detailBig: this.detailBig})
  }

  jumpTo(evt) {
    this.jump.emit(evt)
  }

  resetView() {
    event.stopPropagation()
    this.reset.emit(true)
  }
  hexToAscii(hex: string): string {
    const cleanHex = hex.replace(/[^0-9A-Fa-f]/g, '')

    return (
      cleanHex
        .match(/.{1,2}/g)
        ?.map((byte) => String.fromCharCode(parseInt(byte, 16)))
        .join('') || ''
    )
  }
}
